module.exports = "img/cancel-black.49e1227.png";